import React from "react";
import { guides } from "../data/guides";

function Guides() {
  const isAdmin = false; // Static site → không còn admin
  const message = "";

  return (
    <div className="container max-w-7xl mx-auto px-4 py-8">
      <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-800 tracking-tight mb-6">
        Danh Sách Hướng Dẫn
      </h2>

      {message && (
        <div className="bg-green-100 text-green-700 border border-green-400 px-4 py-3 rounded mb-6 text-center">
          {message}
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {guides.map((guide) => (
          <div
            key={guide.id}
            className="bg-white border border-gray-200 shadow-md rounded-lg p-4"
          >
            <div className="w-full overflow-hidden rounded">
              <iframe
                src={`https://www.tiktok.com/embed/v2/${guide.videoId}`}
                width="100%"
                height="800"
                frameBorder="0"
                allowFullScreen
                title={guide.title}
              ></iframe>
            </div>

            {isAdmin && (
              <div className="text-center mt-4">
                <button className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded shadow transition duration-200">
                  Chỉnh sửa
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Guides;